import * as t from 'ts-schema';
import { registerQuery } from 'data-fetching-client';
import { getApiClient } from '../../clients/apiClient';
import { getQuickFetch } from '../../clients/ecosystemClient';
export const moduleCategoriesResponseSchema = t.object({
  results: t.array(t.object({
    id: t.number,
    name: t.string,
    displayName: t.string
  }))
});
export const GET_MODULE_CATEGORIES_QUERY = registerQuery({
  fieldName: 'moduleCategories',
  args: ['lang'],
  fetcher: ({
    lang
  }) => {
    return getQuickFetch('module-categories').catch(() => {
      return getApiClient().get('content/categories/v1/categories/meta', {
        query: {
          lang
        }
      });
    });
  }
});